import { render, staticRenderFns } from "./AcademicReferencesBasic.vue?vue&type=template&id=de53fd8e&"
import script from "./AcademicReferencesBasic.vue?vue&type=script&lang=js&"
export * from "./AcademicReferencesBasic.vue?vue&type=script&lang=js&"
import style0 from "./AcademicReferencesBasic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de53fd8e')) {
      api.createRecord('de53fd8e', component.options)
    } else {
      api.reload('de53fd8e', component.options)
    }
    module.hot.accept("./AcademicReferencesBasic.vue?vue&type=template&id=de53fd8e&", function () {
      api.rerender('de53fd8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/candidates/academic-references/AcademicReferencesBasic.vue"
export default component.exports